module.exports = "./img/374457f7b24a4b3acbc45cd89411af10.jpg";